import { render, staticRenderFns } from "./ColorsCodesSection.vue?vue&type=template&id=333cd73c"
import script from "./ColorsCodesSection.vue?vue&type=script&lang=ts"
export * from "./ColorsCodesSection.vue?vue&type=script&lang=ts"
import style0 from "./ColorsCodesSection.vue?vue&type=style&index=0&id=333cd73c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports